import * as React from 'react';

import { match } from 'path-to-regexp';

import { AuditLogRootLayout } from './_components/_layouts/_AuditLogRootLayout';
import { useAuditLogLocation } from './_state/auditLogModule.state';
import { MenuItem } from './_types';
import { AuditLogPath, auditLogRouteGroups } from './routes';

// eslint-disable-next-line custom/require-component-classname
const AuditLogRouter = () => {
  const [location, setLocation] = useAuditLogLocation();

  const flattendedRoutes = React.useMemo(
    () => auditLogRouteGroups.flatMap((group) => group.items as MenuItem[]),
    [],
  );

  const CurrentComponent = React.useMemo(() => {
    if (!location) return () => null;

    const exactMatch = flattendedRoutes.find((route) =>
      Array.isArray(route.pattern)
        ? route.pattern.includes(location)
        : route.pattern === location,
    )?.component;

    if (exactMatch) {
      return exactMatch;
    }

    const partialMatch = flattendedRoutes.find((route) => {
      if (Array.isArray(route.pattern)) {
        return route.pattern.some((pattern) => {
          const result = match(pattern)(location);
          return !!result;
        });
      }

      const result = match(route.pattern)(location);

      return !!result;
    })?.component;

    if (partialMatch) {
      return partialMatch;
    }
  }, [flattendedRoutes, location]);

  React.useEffect(() => {
    if (location === '/') {
      setLocation(
        flattendedRoutes.find((route) => !route.disabled)
          ?.pattern as AuditLogPath,
      );
    }
  }, [flattendedRoutes, setLocation, location]);

  if (!location) {
    return null;
  }

  return (
    <AuditLogRootLayout>
      {CurrentComponent && <CurrentComponent />}
    </AuditLogRootLayout>
  );
};

export const auditLogModule = {
  Router: AuditLogRouter,
};

// Re-export shared components for cross-module use
export * from './_components/_shared';
